(() => {
  const initialize = root => {
    if (root.dataset.functionsReady) return;
    const panel = root.querySelector('[data-wek-function-results]');
    if (!panel) return;
    root.dataset.functionsReady = 'true';
    const buttons = [...root.querySelectorAll('[data-wek-function]')];
    const plantButtons = [...root.querySelectorAll('[data-wek-plant]')];
    const plantToggle = root.querySelector('[data-wek-plant-open]');
    const plantMenu = root.querySelector('#wm-plant-parts');
    
    const plantOf = title => { const t = title.toLowerCase(); const parts = new Set(); const add = (part, re) => { if(re.test(t))parts.add(part); }; add('Root', /\b(root|roots)\b/);add('Leaf', /\b(leaf|leaves)\b/);add('Flower', /\b(flower|flowers|blossom|blossoms|bud|buds|elderflower)\b/);add('Bark', /\bbark\b/);add('Seed', /\b(seed|seeds)\b/);add('Berry', /\b(berry|berries|elderberry|bilberry|blueberry|raspberry|blackberry|strawberry|chokeberry)\b/);add('Fruit', /\b(fruit|fruits)\b/);add('Herb', /\b(herb|aerial parts)\b/);if(!parts.size)parts.add('Other');return parts; };
    const grid = panel.querySelector('[data-wek-function-grid]');
    const status = panel.querySelector('[role="status"]');
    const heading = panel.querySelector('h2');
    let cached, pending, sequence = 0;
    const originalPanels = [...root.querySelectorAll('.wm-product-layout, [data-wek-gallon-results]')];
    const previousVisibility = new Map();
    const hideSelection = () => originalPanels.forEach(el => {
      if (!previousVisibility.has(el)) previousVisibility.set(el, el.hidden);
      el.hidden = true;
    });
    const restoreSelection = () => {
      previousVisibility.forEach((hidden, el) => { el.hidden = hidden; });
      previousVisibility.clear();
    };
    const clear = () => {
      sequence++;
      buttons.concat(plantButtons).forEach(button => button.setAttribute('aria-pressed', 'false'));
      panel.hidden = true;
      panel.removeAttribute('aria-busy');
      restoreSelection();
    };
    const load = () => {
      if (cached) return Promise.resolve(cached);
      if (pending) return pending;
      pending = (async () => {
        let url = new URL(panel.dataset.catalog, location.origin);
        const cards = [], seen = new Set(), visited = new Set();
        while (url) {
          if (url.origin !== location.origin || visited.has(url.href)) throw Error('Invalid pagination');
          visited.add(url.href);
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw Error('Catalog unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = doc.querySelector('[data-wek-function-source]');
          if (!source) throw Error('Catalog unavailable');
          source.querySelectorAll('[data-wek-function-card]').forEach(card => {
            if (seen.has(card.dataset.productId)) return;
            seen.add(card.dataset.productId);
            cards.push(card);
          });
          const next = source.querySelector('[data-wek-function-next]');
          url = next ? new URL(next.getAttribute('href'), location.origin) : null;
        }
        cached = cards;
        return cards;
      })().catch(error => { pending = null; throw error; });
      return pending;
    };
    buttons.concat(plantButtons).forEach(button => button.addEventListener('click', async () => {
      const ticket = ++sequence, isPlant = button.hasAttribute('data-wek-plant'), selected = isPlant ? button.dataset.wekPlant : button.textContent.trim();
      buttons.concat(plantButtons).forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      heading.textContent = selected;
      grid.replaceChildren();
      hideSelection();
      panel.hidden = false;
      panel.setAttribute('aria-busy', 'true');
      status.textContent = panel.dataset.loading;
      try {
        const cards = await load();
        if (ticket !== sequence) return;
        const matches = cards.filter(card => {
          const functions = JSON.parse(card.dataset.functions || '[]') || [];
          const variants = JSON.parse(card.dataset.variants || '[]');
          const sample = /\bsample\b/i.test(card.dataset.title);
          const eligible = root.dataset.mode === 'evaluate'
            ? sample && variants.some(title => /^(1|2|4)\s*(?:OZ|OUNCE)\b/i.test(title))
            : !sample && !/fee|label|shipping|bottl|business in a box/i.test(card.dataset.title) &&
              (/extract|glycerin/i.test(card.dataset.title) || String(card.dataset.productId) === '8267453727034') &&
              (variants.some(title => /^\d+(?:\.\d+)?\s+(?:GAL|GALLON|GALLONS)(?:\s|$)/i.test(title)) ||
               /extract.*1 gal/i.test(card.dataset.title));
          return eligible && (isPlant ? plantOf(card.dataset.plantTitle || card.dataset.title).has(selected) : functions.includes(selected));
        });
        grid.replaceChildren(...matches.map(card => {
          const copy = card.cloneNode(true), link = copy.querySelector('a');
          const url = new URL(link.getAttribute('href'), location.origin);
          url.searchParams.set('view', panel.dataset.productView);
          if (panel.dataset.theme) url.searchParams.set('preview_theme_id', panel.dataset.theme);
          else url.searchParams.delete('preview_theme_id');
          url.searchParams.set('_fd', '0');
          url.searchParams.set('pb', '0');
          url.hash = 'wek-selected-product';
          link.href = url.pathname + url.search + url.hash;
          return copy;
        }));
        status.textContent = matches.length
          ? panel.dataset.count.replace('[count]', String(matches.length))
          : panel.dataset.empty;
      } catch (error) {
        if (ticket === sequence) status.textContent = panel.dataset.error;
      } finally {
        if (ticket === sequence) {
          panel.removeAttribute('aria-busy');
          panel.scrollIntoView({ block: 'start', behavior: 'auto' });
        }
      }
    }));
    panel.querySelector('[data-wek-function-clear]').addEventListener('click', () => {
      clear();
      (plantButtons.find(b => b.getAttribute('aria-pressed') === 'true') || buttons[0])?.focus();
    });
    root.querySelectorAll('.wm-header form, #wm-product-search').forEach(form => form.addEventListener('submit', clear));
  };
  document.querySelectorAll('.wm-master[data-mode]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.wm-master[data-mode]').forEach(initialize));
})();

